import { TAB_KEYS, type TabKey } from './useTabParam';
import styles from './SubTabs.module.css';

const LABELS: Record<TabKey, string> = {
  overview: 'Overview',
  engagement: 'Engagement',
  games: 'Games & Missions',
  rewards: 'Rewards & Coupons',
  consents: 'Consents',
};

export function SubTabs({
  active,
  onSelect,
  available = TAB_KEYS,
  labels,
}: {
  active: TabKey;
  onSelect: (next: TabKey) => void;
  /** Tabs to render — defaults to all. Region-specific tabs (e.g. Consents
   *  for France) are omitted by passing a filtered list from DashboardPage. */
  available?: ReadonlyArray<TabKey>;
  /** Per-report label overrides (DashboardConfig.tabLabels). */
  labels?: Partial<Record<TabKey, string>>;
}) {
  return (
    <div className={styles.tabs} role="tablist" aria-label="Dashboard sections">
      {available.map((id) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={active === id}
          className={`${styles.tab} ${active === id ? styles.active : ''}`}
          onClick={() => onSelect(id)}
        >
          {labels?.[id] ?? LABELS[id]}
        </button>
      ))}
    </div>
  );
}
